import { render, staticRenderFns } from "./ResendVerificationCode.vue?vue&type=template&id=5c3de30e&scoped=true&"
import script from "./ResendVerificationCode.vue?vue&type=script&lang=js&"
export * from "./ResendVerificationCode.vue?vue&type=script&lang=js&"
import style0 from "./ResendVerificationCode.vue?vue&type=style&index=0&id=5c3de30e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3de30e",
  null
  
)

component.options.__file = "ResendVerificationCode.vue"
export default component.exports